export default {
    title: "Order on behalf of",
    model: {
        email: {
            label: "Email",
            placeholder: "Please fill user email",
            errors: {
                myself: "Email must differ from your"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "Submit",
            processing: "Submitting"
        }
    },
    error: {
        userNotExists: "{email} does not exist",
        country: {
            default: "Gear is currently unavailable in user country",
            ALPHA3: ""
        }
    }
}